import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { SET_USER } from '../user/userActions';
import { PLAY_AUDIO } from '../audio/audioActions';

export const dataDogAddWarning = (message, context = {}) => {
    if (datadogLogs) {
        datadogLogs.logger.warn(message, context);
    }
};

// For high-frequency user interactions (e.g. a button press on every normal
// completion) — a RUM action is the right channel: it is sampled and kept out
// of the warn log stream, so it does not pollute or inflate the logs.
export const dataDogAddAction = (name, context = {}) => {
    if (datadogRum) {
        datadogRum.addAction(name, context);
    }
};

const createDataDogMiddleware = () => {
    return store => next => action => {
        if (datadogRum) {
            try {
                if (action.type === SET_USER) {
                    datadogRum.setUser({
                        id: action.userId,
                    });
                }
                if (action.aquaId) {
                    datadogRum.setGlobalContextProperty('boost', {
                        app_name: 'reading',
                        aqua_id: action.aquaId,
                    });
                }
                if (action.error) {
                    dataDogAddWarning('Redux action error', { error: action.error });
                }
                // STEAM-8604: a PLAY_AUDIO dispatched while audio is already
                // active is silently dropped by the reducer, orphaning any
                // blockScreen() tied to that never-stored onEndCallback (e.g. a
                // double-tap on the avatar). getState() here is pre-reducer, so
                // isReadyToPlay still reflects the in-flight audio.
                if (action.type === PLAY_AUDIO && store.getState().audio?.isReadyToPlay) {
                    dataDogAddWarning('Audio play dispatch dropped (audio already active)');
                }
                // eslint-disable-next-line no-unused-vars
            } catch (e) {
                // ignore DD failures
            }
        }
        next(action);
    };
};

export default createDataDogMiddleware;
